import React from "react";
import { AreaChartBox } from "./AreaChartBox";
import { bool, string, object } from "prop-types";

// LineChartBox is a wrapper around AreaChartBox with fillArea set to false.
export const LineChartBox = (props: any) => {
  return <AreaChartBox {...props} fillArea={false} />;
};

LineChartBox.propTypes = {
  loading: bool,
  title: string,
  data: object,
};
